import Vue from "vue";
import isValid from "date-fns/isValid";
import isDate from "date-fns/isDate";
import format from "date-fns/format";

Vue.filter("date", (date, dateFormat = "dd/MM/yyyy") => {
    let prepared = date;

    if (!isDate(prepared)) {
        prepared = new Date(prepared);
    }

    if (!isValid(prepared)) {
        return date;
    }

    return format(prepared, dateFormat);
});
